import { Box, Heading, Text } from '@chakra-ui/react'
import React from 'react'

export const Fourth = () => {
  return (
    <>
    
    <Box display={"flex"} justifyContent={"center"} p={5} mt={"120px"}>

<Box>
<Box textAlign={"center"} >
<Heading size='md' mt={5}  mb={4} color="blue">4. COORDINATE WITH EASE</Heading>
<Heading mb={4} mt={"5"}>Collaboration has never been easier</Heading>
<Text fontSize='2xl' mt={10}>
With Buffer’s permissions levels and approval flows, your team can work freely without any micro-management.
</Text>
</Box>
</Box>
</Box>


    
    </>
  )
}
